<template>
	<div class="container">
		<myHeader></myHeader>
		<div class="main">
			<div class="policy-detail">
				<div class="title">
					{{ policyData.markPoliciesTitle }}
				</div>
				<div class="info">
					<div class="left">
						<span class="type" v-if="policyData.markPoliciesType == 1">财税减免</span>
						<span class="type" v-if="policyData.markPoliciesType == 2">奖补帮扶</span>
						<span class="type" v-if="policyData.markPoliciesType == 3">优化服务</span>
						<span class="type" v-if="policyData.markPoliciesType == 4">金融信贷</span>
						<span class="type" v-if="policyData.markPoliciesType == 5">要素保障</span>
						<span class="level" v-if="policyData.markPoliciesLevel == 1">国家级</span>
						<span class="level" v-if="policyData.markPoliciesLevel == 2">省级</span>
						<span class="level" v-if="policyData.markPoliciesLevel == 3">市级</span>
						<span class="level" v-if="policyData.markPoliciesLevel == 4">区县级</span>
					</div>
					<div class="right">
						<!-- <span>{{ policyData.markPoliciesPublishTime }}</span> -->
					</div>
				</div>
				<div class="content" v-html="policyData.markPoliciesBasis"></div>
				<div class="link" @click="toWebLink(policyData.markPoliciesInterpretLink)">
					<span>点击查看解读</span>
				</div>
			
			</div>
		</div>
		<!-- 尾部 -->
		<myFooter></myFooter>
		<!-- 侧边悬浮 -->
		<sideFloat></sideFloat>
		<!-- 底部菜单 -->
		<bottomMenu></bottomMenu>
	</div>
</template>

<script>
	import {
		ref,
		defineComponent
	} from 'vue'
	import {
		useRoute
	} from 'vue-router'
	import {
		ElMessage
	} from 'element-plus'
	import {
		getPolicyDetail
	} from '@/axios/api'
	import myHeader from '@/components/layouts/myHeader'
	import myFooter from '@/components/layouts/myFooter'
	import bottomMenu from '@/components/layouts/bottomMenu'
	import sideFloat from '@/components/layouts/sideFloat'
	export default defineComponent({
		components: {
			myHeader,
			myFooter,
			bottomMenu,
			sideFloat
		},
		setup() {
			const route = useRoute();
			const policyData = ref('');
			
			(function getData() {
				getPolicyDetail('/cdMapApi/api/policy/detail/' + route.query.policyId, {
			
				}).then(function(res) {
					let {
						code,
						data,
						msg
					} = res.data;
					if (code == 200) {
						console.log('data:', data)
						// 当前渲染数据列表
						policyData.value = data
			
					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				})
			})();
			
			// 解读跳转
			function toWebLink(url) {
				window.location.href = url
			}
			
			return {
				policyData,
				toWebLink
			}
		}
	})
</script>

<style lang="scss">
	.container {
		height: auto;
		min-height: 100vh;
		margin: 0;
		padding: 0;
	
		.main {
			
			.policy-detail {
				background: #fff;
				padding: 15px;
				
				.title {
					line-height: 25px;
					font-size: 18px;
					font-weight: bold;
					text-align: center;
					color: #333;
					border-bottom: #c1c1c1 1px solid;
					padding-bottom: 10px;
					margin-bottom: 10px;
				}
				
				.info {
					display: flex;
					justify-content: space-between;
					color: #999;
					height: 30px;
					line-height: 30px;
					
					.left {
						span {
							background: #37a9fe;
							padding: 5px 8px;
							margin-right: 10px;
							color: #fff;
							border-radius: 5px;
						}
					}
				}
				
				.content {
					padding: 10px 0px;
					background: #fff;
					text-align: justify;
				}
				
				.link {
					text-align: right;
					margin-bottom: 20px;
					
					span {
						padding: 5px 10px;
						border: #37a9fe 1px solid;
						border-radius: 5px;
					}
				}
			}
		}
	}
</style>